module.exports = __webpack_public_path__ + "static/media/VK.2eb3c113.svg";